import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import { Fragment, useEffect } from "react";
import { Col } from "reactstrap";
import { CALENDAR_INITIAL_DATA } from "../../Data/Calendar";
import CalendarEvents from "./CalendarEvents";
import { calenderEventClick } from "./CalenderFunction";

const DragCalendar = () => {
  const state = CALENDAR_INITIAL_DATA;
  useEffect(() => {
    const draggableEl = document.getElementById("external-events") as HTMLElement;
    new Draggable(draggableEl, {
      itemSelector: ".fc-event",
      eventData: function (eventEl) {
        let title = eventEl.getAttribute("title");
        let id = eventEl.getAttribute("id");
        return {
          title: title,
          id: id,
        };
      },
    });
  }, []);
  
  return (
    <Fragment>
      <CalendarEvents state={state} />
      <Col xl="9" md="8" className="box-col-8">
        <div className="demo-app-calendar" id="mycalendartest">
          <FullCalendar eventClick={calenderEventClick} rerenderDelay={10} eventDurationEditable={false} editable={true} droppable={true} plugins={[dayGridPlugin, interactionPlugin]} events={state.calendarEvents} />
        </div>
      </Col>
    </Fragment>
  );
};
export default DragCalendar;